export const contactEmail = 'digitara15@gmail.com';
export const contactPhone = '0815-8502-0920';
export const contactPhoneDigits = '6281585020920';

export const siteContent = {
  id: {
    nav: {
      about: 'Tentang Kami',
      services: 'Layanan',
      team: 'Harga',
      works: 'Karya Kami',
      contact: 'Kontak',
      getStarted: 'Mulai Sekarang',
      language: 'EN',
      languageLabel: 'Ganti bahasa ke Inggris',
    },
    footer: {
      tagline: 'Mitra transformasi digital yang rapi, cepat, dan bisa diandalkan.',
      copyright: '© 2026 PT DIGITARA TEKNOLOGI NUSANTARA. Seluruh hak cipta dilindungi.',
      privacy: 'Kebijakan Privasi',
      terms: 'Syarat Layanan',
      cookies: 'Pengaturan Cookie',
      connect: 'Terhubung',
      contact: 'Kontak Cepat',
    },
    home: {
      title: 'Menjadi penunjuk arah untuk transformasi digital bisnis Anda',
      subtitle: 'Selamat datang di DIGITARA: mitra tepercaya untuk masa depan digital Anda.',
      primary: 'Mulai Transformasi',
      secondary: 'Pelajari Lebih Lanjut',
      tagOne: 'Presisi berbasis data',
      tagTwo: 'Skalabilitas tanpa batas',
    },
    about: {
      eyebrow: 'Filosofi Kami',
      title: 'Digital meets <strong>Tara</strong>',
      description:
        'DIGITARA adalah perpaduan antara dunia digital yang presisi dan tara, bintang atau cahaya. Kami hadir untuk menerangi jalan transformasi bisnis Anda di era digital dengan solusi yang tajam dan terukur.',
      historyLabel: 'Sejarah',
      historyTitle: 'Lahirnya Bintang Baru',
      historyText:
        'Resmi berdiri pada 15 April 2026, DIGITARA memulai perjalanannya dengan komitmen kuat untuk menjembatani kesenjangan antara teknologi mutakhir dan kebutuhan bisnis praktis.',
      visionLabel: 'Visi',
      visionTitle: 'Arah Navigasi',
      visionText: 'Menjadi mitra transformasi digital terdepan.',
      missionLabel: 'Misi',
      missionTitle: 'Pilar Transformasi',
      missions: [
        {
          title: 'Solusi berdampak nyata',
          text: 'Menghadirkan arsitektur digital yang memberikan hasil terukur bagi ekosistem bisnis.',
        },
        {
          title: 'Membantu bisnis berkembang',
          text: 'Mendorong skala pertumbuhan melalui strategi teknologi yang adaptif dan visioner.',
        },
        {
          title: 'Layanan cepat & terpercaya',
          text: 'Eksekusi presisi dengan standar reliabilitas tinggi untuk setiap implementasi sistem.',
        },
        {
          title: 'Inovasi berkelanjutan',
          text: 'Eksplorasi tanpa henti pada batas teknologi untuk menjaga relevansi di masa depan.',
        },
      ],
    },
    services: {
      eyebrow: 'Keahlian Kami',
      title: 'Merancang Masa Depan',
      titleHighlight: 'Digital',
      subtitle:
        'Kami membangun ekosistem digital yang skalabel. Presisi bertemu kemungkinan tak terbatas melalui layanan inti kami.',
      explore: 'Lihat Detail',
      cards: [
        {
          title: 'Pengembangan Perangkat Lunak',
          text: 'Aplikasi yang direkayasa dengan presisi untuk skala besar. Kami menerjemahkan logika bisnis yang kompleks menjadi arsitektur kode yang elegan dan andal.',
        },
        {
          title: 'Transformasi Digital',
          text: 'Modernisasi sistem lama dan integrasi alur kerja baru. Kami memandu organisasi melalui perubahan teknologi yang mendasar.',
        },
        {
          title: 'Konsultasi TI',
          text: 'Arahan strategis untuk era digital. Kami menyelaraskan infrastruktur teknologi dengan tujuan bisnis jangka panjang.',
        },
        {
          title: 'Desain UI/UX',
          text: 'Merancang pengalaman pengguna yang intuitif dan antarmuka yang memukau. Kami memadukan estetika visual dengan fungsionalitas untuk interaksi digital yang mulus.',
        },
        {
          title: 'Infrastruktur Hardware',
          text: 'Penyediaan dan optimalisasi perangkat keras berkinerja tinggi. Kami membangun fondasi infrastruktur fisik yang tangguh untuk keandalan operasional penuh.',
        },
      ],
    },
    team: {
      eyebrow: 'Paket Harga',
      title: 'Solusi Digital',
      titleHighlight: 'Terjangkau',
      subtitle:
        'Pilih paket yang sesuai dengan kebutuhan bisnis Anda. Dari UMKM hingga perusahaan besar, kami siap membantu.',
      waNumber: '6281585020920',
      waGreeting: 'Halo Digitara, saya tertarik dengan',
      ctaLabel: 'Pilih Paket',
      saveBadge: 'Hemat Lebih Banyak',
      popularBadge: 'Paling Populer',
      customPrice: 'Custom / Via WhatsApp',
      plans: [
        {
          id: 'umkm',
          name: 'Paket UMKM',
          price: 'Rp 360.000',
          originalPrice: 'Rp 500.000',
          discount: '28% OFF',
          tagline: 'Solusi terbaik untuk bisnis kecil dan menengah.',
          features: [
            'UI/UX Design',
            'Front-end Development',
            'Hosting (Perbaruan: Rp 30.000/bln)',
            'Domain Gratis (.my.id / .groups.id)',
            'Custom Domain (+ Biaya Tambahan)',
            'SSL Security',
            'Garansi Revisi Tanpa Batas',
          ],
          isPopular: false,
          isCustom: false,
        },
        {
          id: 'startup',
          name: 'Paket Startup',
          price: 'Rp 650.000',
          originalPrice: 'Rp 800.000',
          discount: '19% OFF',
          tagline: 'Semua yang Anda butuhkan untuk tumbuh lebih cepat.',
          features: [
            'Semua Fitur Paket UMKM',
            'Hosting (Perbaruan: Rp 80.000/bln)',
            'Integrasi Database',
            'Back-end Development',
            'Sistem CRUD Lengkap',
          ],
          isPopular: true,
          isCustom: false,
        },
        {
          id: 'company',
          name: 'Paket Company',
          price: 'Custom / Via WhatsApp',
          originalPrice: null,
          discount: null,
          tagline: 'Solusi enterprise skala penuh yang disesuaikan.',
          features: [
            'Paket Super Lengkap',
            'Custom Domain (.com, .net, dll)',
            'Diskon 10% Renewal Domain',
            'High Maintenance & Support',
          ],
          isPopular: false,
          isCustom: true,
        },
      ],
    },
    works: {
      eyebrow: 'Karya Kami',
      title: 'Jejak Digital',
      titleHighlight: 'Yang Kami Bangun',
      subtitle: 'Telusuri mahakarya digital yang telah kami wujudkan. Dari konsep hingga eksekusi, kami menghadirkan solusi yang berdampak nyata.',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      visitSite: 'Kunjungi Website',
      loadMore: 'Muat Lebih Banyak',
      clientsTitle: 'Klien Kami',
    },
    contact: {
      eyebrow: 'Hubungi Kami',
      title: 'Hubungi Kami',
      subtitle: 'Sampaikan pesan Anda dan tim ahli kami akan membantu transformasi digital Anda.',
      name: 'Nama Lengkap',
      email: 'Alamat Email',
      message: 'Pesan',
      namePlaceholder: 'Nama Anda',
      emailPlaceholder: 'nama@contoh.com',
      messagePlaceholder: 'Jelaskan kebutuhan Anda...',
      submit: 'Kirim ke Email',
      whatsapp: 'Hubungi via WhatsApp',
      note: 'Pesan akan dibuka ke email resmi kami dan juga tersedia opsi WhatsApp.',
      modalTitle: 'Pesan siap dikirim',
      modalText: 'Aplikasi email Anda sedang dibuka dengan pesan yang sudah diisi.',
      modalButton: 'Tutup',
    },
  },
  en: {
    nav: {
      about: 'About Us',
      services: 'Services',
      team: 'Pricing',
      works: 'Our Work',
      contact: 'Contact',
      getStarted: 'Get Started',
      language: 'ID',
      languageLabel: 'Switch language to Indonesian',
    },
    footer: {
      tagline: 'A digital transformation partner that is precise, fast, and reliable.',
      copyright: '© 2026 PT DIGITARA TEKNOLOGI NUSANTARA. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Settings',
      connect: 'Connect',
      contact: 'Quick Contact',
    },
    home: {
      title: 'Guiding your business through digital transformation',
      subtitle: 'Welcome to DIGITARA: a trusted partner for your digital future.',
      primary: 'Start Transformation',
      secondary: 'Learn More',
      tagOne: 'Data-driven precision',
      tagTwo: 'Unlimited scalability',
    },
    about: {
      eyebrow: 'Our Philosophy',
      title: 'Digital meets <strong>Tara</strong>',
      description:
        'DIGITARA blends the precision of the digital world with tara, a star or a light. We are here to illuminate your business transformation journey in the digital era with sharp, measurable solutions.',
      historyLabel: 'History',
      historyTitle: 'The Birth of a New Star',
      historyText:
        'Officially founded on 15 April 2026, DIGITARA began with a strong commitment to bridge the gap between advanced technology and practical business needs.',
      visionLabel: 'Vision',
      visionTitle: 'Navigation Path',
      visionText: 'To become the leading digital transformation partner.',
      missionLabel: 'Mission',
      missionTitle: 'Pillars of Transformation',
      missions: [
        {
          title: 'Meaningful impact solutions',
          text: 'Delivering digital architecture that creates measurable outcomes for business ecosystems.',
        },
        {
          title: 'Helping businesses grow',
          text: 'Driving scale through adaptive and visionary technology strategies.',
        },
        {
          title: 'Fast & reliable delivery',
          text: 'Precision execution with high reliability standards for every system implementation.',
        },
        {
          title: 'Continuous innovation',
          text: 'Endless exploration of technology boundaries to stay relevant for the future.',
        },
      ],
    },
    services: {
      eyebrow: 'Our Expertise',
      title: 'Architecting the',
      titleHighlight: 'Future',
      subtitle:
        'We engineer scalable digital ecosystems. Precision meets infinite possibility through our core service offerings.',
      explore: 'Explore Capability',
      cards: [
        {
          title: 'Software Development',
          text: 'Precision-engineered applications built for scale. We translate complex business logic into elegant, performant code architectures.',
        },
        {
          title: 'Digital Transformation',
          text: 'Modernize legacy systems and integrate cutting-edge workflows. We guide organizations through fundamental technological shifts.',
        },
        {
          title: 'IT Consulting',
          text: 'Strategic guidance for the digital age. We align technology infrastructure with long-term business objectives.',
        },
        {
          title: 'UI/UX Design',
          text: 'Crafting intuitive user journeys and stunning interfaces. We blend visual aesthetics with functionality for seamless digital interactions.',
        },
        {
          title: 'Hardware Infrastructure',
          text: 'Provisioning and optimizing high-performance hardware. We build resilient physical foundations for dependable operations.',
        },
      ],
    },
    team: {
      eyebrow: 'Pricing Plans',
      title: 'Affordable Digital',
      titleHighlight: 'Solutions',
      subtitle:
        'Choose the plan that fits your business needs. From SMEs to large companies, we are ready to help.',
      waNumber: '6281585020920',
      waGreeting: 'Halo Digitara, saya tertarik dengan',
      ctaLabel: 'Choose Plan',
      saveBadge: 'Save Money',
      popularBadge: 'Most Popular',
      customPrice: 'Custom / Via WhatsApp',
      plans: [
        {
          id: 'umkm',
          name: 'UMKM Package',
          price: 'Rp 360.000',
          originalPrice: 'Rp 500.000',
          discount: '28% OFF',
          tagline: 'The best solution for small and medium-sized businesses.',
          features: [
            'UI/UX Design',
            'Front-end Development',
            'Hosting (Renewal: Rp 30.000/mo)',
            'Free Domain (.my.id / .groups.id)',
            'Custom Domain (+ Extra Cost)',
            'SSL Security',
            'Unlimited Free Revisions',
          ],
          isPopular: false,
          isCustom: false,
        },
        {
          id: 'startup',
          name: 'Startup Package',
          price: 'Rp 650.000',
          originalPrice: 'Rp 800.000',
          discount: '19% OFF',
          tagline: 'Everything you need to grow faster.',
          features: [
            'All UMKM Package Features',
            'Hosting (Renewal: Rp 80.000/mo)',
            'Database Integration',
            'Back-end Development',
            'Full CRUD System',
          ],
          isPopular: true,
          isCustom: false,
        },
        {
          id: 'company',
          name: 'Company Package',
          price: 'Custom / Via WhatsApp',
          originalPrice: null,
          discount: null,
          tagline: 'Fully customized enterprise-scale solutions.',
          features: [
            'Complete Super Package',
            'Custom Domain (.com, .net, etc.)',
            '10% Domain Renewal Discount',
            'High Maintenance & Support',
          ],
          isPopular: false,
          isCustom: true,
        },
      ],
    },
    works: {
      eyebrow: 'Our Work',
      title: 'Digital Footprints',
      titleHighlight: 'We Have Built',
      subtitle: 'Explore the digital masterpieces we have brought to life. From concept to execution, we deliver impactful solutions.',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      visitSite: 'Visit Website',
      loadMore: 'Load More',
      clientsTitle: 'Our Clients',
    },
    contact: {
      eyebrow: 'Contact Us',
      title: 'Contact Us',
      subtitle: 'Send us a message and our team will help with your digital transformation.',
      name: 'Full Name',
      email: 'Email Address',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'name@example.com',
      messagePlaceholder: 'Tell us about your needs...',
      submit: 'Send to Email',
      whatsapp: 'Contact via WhatsApp',
      note: 'Your message will be prepared for our official email and WhatsApp is also available.',
      modalTitle: 'Message ready to send',
      modalText: 'Your email app is being opened with the message prefilled.',
      modalButton: 'Close',
    },
  },
};

export function buildWhatsAppLink(message = '') {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${contactPhoneDigits}${encodedMessage ? `?text=${encodedMessage}` : ''}`;
}
